import React from 'react';
// material
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import Iconify from "../components/Iconify";
import EditIcon from '@mui/icons-material/Edit';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useSelector } from 'react-redux'
import { setSearchCriteriaValue, searchPhaseSelected, searchFundSelected, testApi, searchSubmit, getCondtionList, getSerchCount } from '../redux/actions'
import { useDispatch } from 'react-redux'
import PropTypes from "prop-types";
import {
    OutlinedInput,
    Stack,
    Checkbox,
    FormControl,
    FormControlLabel,
    InputAdornment,
    /*FormHelperText,*/
    CircularProgress,
    TextField,
    useMediaQuery,
    Box,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import MainCard from "../components/MainCard";
import { useTheme } from '@mui/material/styles';
// ----------------------------------------------------------------------
const AuthWrapper1 = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.primary.grey,
    minHeight: '100vh'
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
    '&.Mui-focused': { /*width: 520,*/ boxShadow: theme.customShadows.z8, background: "#fff" },
    '& fieldset': {
        borderWidth: `1px !important`,
        /*borderColor: "rgba(0,72,132, 0.24)"*/
        borderColor: `${theme.palette.grey[500_32]} !important`,
    },
}));

const LogoStyle = styled('div')({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
});
/*
const rightAling = {
    justifyContent: 'right'
}
*/


// ----------------------------------------------------------------------
const AuthCardWrapper = ({ children, ...other }) => (
    <MainCard
        sx={{
            maxWidth: { xs: 400, lg: 475 },
            margin: { xs: 2.5, md: 3 },
            '& > *': {
                flexGrow: 1,
                flexBasis: '50%'
            }
        }}
        content={false}
        {...other}
    >
        <Box sx={{ p: { xs: 2, sm: 3, xl: 5 } }}>{children}</Box>
    </MainCard>
);


export default function SearchPage() {

    const dispatch = useDispatch()
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const loading = useSelector((state) => state.loading)
    const apiWarmedUp = useSelector((state) => state.apiWarmedUp)
    const searchCriteria = useSelector((state) => state.searchCriteria)
    const conditions = useSelector((state => state.conditions))
    const searchCount = useSelector((state => state.searchCount))
    //const search_error = useSelector((state => state.search_error))

    const [search/*, setSearch*/] = React.useState(10);
    const [expanded, setExpanded] = React.useState(false);
    const [expandedAdv, setExpandedAdv] = React.useState(false);
    const [input, setInput] = React.useState("")


    const handleOptionsChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleADVChange = (panel) => (event, isExpanded) => {
        setExpandedAdv(isExpanded ? panel : false);
    }

    React.useEffect(() => {
        const testApiThunk = testApi()
        if (!apiWarmedUp) {
            dispatch(testApiThunk)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (input !== "") {
            const getSerchCountThunk = getSerchCount()
            const timeOutId = setTimeout(() => dispatch(getSerchCountThunk), 200);
            return () => clearTimeout(timeOutId);
        }
    }, [input, dispatch]);


    const selected = (id, type) => {
        var result = searchCriteria[type].filter(obj => {
            return obj.id === id
        })
        return result[0].value
    }

    const submitSearch = () => {
        const searchSubmitThunk = searchSubmit()
        dispatch(searchSubmitThunk)
    }

    const handleAutoInputChange = (event, value) => {
        //const getCondtionListThunk = getCondtionList("cond", value)
        //dispatch(getCondtionListThunk)
        const setSearchCriteriaValueThunk = setSearchCriteriaValue("cond", value)
        dispatch(setSearchCriteriaValueThunk)

        if (value.length > 4) {
            setInput(value)
        }
    }

    const handleAutoChange = (event, value) => {
        const setSearchCriteriaValueThunk = setSearchCriteriaValue("cond", value)
        dispatch(setSearchCriteriaValueThunk)
        //const getSerchCountThunk = getSerchCount()
        //dispatch(getSerchCountThunk)
        setInput(value)
    }

    const handleChange = event => {
        const { id, value } = event.target
        const setSearchCriteriaValueThunk = setSearchCriteriaValue(id, value)
        dispatch(setSearchCriteriaValueThunk)
        //const getSerchCountThunk = getSerchCount()
        //dispatch(getSerchCountThunk)
        setInput(value)
    }

    const handlePhaseChange = (value) => {
        const searchPhaseSelectedThunk = searchPhaseSelected(value, "phase")
        dispatch(searchPhaseSelectedThunk)
        //const getSerchCountThunk = getSerchCount()
        //dispatch(getSerchCountThunk)
        setInput(value)
    }

    const handleFundChange = (value) => {
        const searchFundSelectedThunk = searchFundSelected(value, "fund")
        dispatch(searchFundSelectedThunk)
        //const getSerchCountThunk = getSerchCount()
        //dispatch(getSerchCountThunk)
        setInput(value)
    }

    return (
        <AuthWrapper1>
            <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                        <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                            <AuthCardWrapper>
                                <Grid container spacing={2} alignItems="center" justifyContent="center">
                                    <Grid item sx={{ mb: 1 }}>
                                        <LogoStyle>
                                            <TravelExploreIcon sx={{ color: '#3366FF', width: 55, height: 55 }} />
                                        </LogoStyle>
                                    </Grid>
                                    {loading && <CircularProgress variant="determinate" value={search} />}
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            direction={matchDownSM ? 'column-reverse' : 'row'}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Grid item sx={{ mb: 2 }}>
                                                <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                    <Typography
                                                        color="#004884"
                                                        gutterBottom
                                                        variant={matchDownSM ? 'h3' : 'h2'}
                                                    >
                                                        A clear view of the medical trials landscape
                                                    </Typography>
                                                </Stack>
                                            </Grid>

                                            {/* Main search field  */}
                                            <Stack spacing={3}>
                                                <FormControl variant="outlined">
                                                    <Autocomplete
                                                        value={searchCriteria["cond"]}
                                                        onChange={handleAutoChange}
                                                        onInputChange={handleAutoInputChange}
                                                        freeSolo
                                                        id="cond"
                                                        disableClearable
                                                        options={conditions.map((option) => option)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                /*label="Enter condition or disease e.g Diabetes"*/
                                                                placeholder="Condition or disease e.g. Diabetes"
                                                                onKeyPress={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        submitSearch();
                                                                    }
                                                                }}
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    type: 'search',

                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                                                                        </InputAdornment>
                                                                    ),
                                                                }}

                                                            />
                                                        )}
                                                    />
                                                </FormControl>

                                                {/* Advanced search options */}
                                                <Accordion
                                                    elevation={0}
                                                    sx={{
                                                        '&:before': {
                                                            display: 'none',
                                                        }
                                                    }}
                                                    expanded={expandedAdv === 'panelAdv'}
                                                    onChange={handleADVChange('panelAdv')}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<MoreHorizIcon />}
                                                        aria-controls="panelAdv-content"
                                                        id="panelAdv-header"
                                                        sx={{ padding: 0 }}
                                                    >
                                                        <Typography sx={{ color: 'text.secondary' }}>Advanced search</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        {/* Other search terms selection  */}
                                                        <Accordion
                                                            expanded={expanded === 'panel1'}
                                                            onChange={handleOptionsChange('panel1')}
                                                            elevation={0}
                                                            sx={{
                                                                '&:before': {
                                                                    display: 'none',
                                                                }
                                                            }}
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={<EditIcon />}
                                                                aria-controls="panel1bh-content"
                                                                id="panel1bh-header"
                                                                sx={{ padding: 0 }}
                                                            >
                                                                <Typography sx={{ color: 'text.secondary' }}>Other terms</Typography>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                {/*<FormControl variant="outlined">*/}
                                                                <SearchStyle
                                                                    id="term"
                                                                    fullWidth
                                                                    placeholder="Company name / drug name / NCT number"
                                                                    value={searchCriteria.term}
                                                                    onChange={handleChange}
                                                                    startAdornment={
                                                                        <InputAdornment position="start">
                                                                            <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                                                                        </InputAdornment>
                                                                    }
                                                                />
                                                                {/*</FormControl>*/}
                                                            </AccordionDetails>
                                                        </Accordion>

                                                        {/* Phase selection  */}
                                                        <Accordion
                                                            expanded={expanded === 'panel2'}
                                                            onChange={handleOptionsChange('panel2')}
                                                            elevation={0}
                                                            sx={{
                                                                '&:before': {
                                                                    display: 'none',
                                                                }
                                                            }}
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={<EditIcon />}
                                                                aria-controls="panel2bh-content"
                                                                id="panel2bh-header"
                                                                sx={{ padding: 0 }}
                                                            >
                                                                <Typography sx={{ color: 'text.secondary' }}>
                                                                    {searchCriteria["phase"].filter(i => i.value === true).map(p => p.text).join(', ')}
                                                                </Typography>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                <Stack direction="column" alignItems="left" justifyContent="left" sx={{ my: 2 }}>
                                                                    {searchCriteria["phase"].map((item, i) =>
                                                                        <FormControlLabel
                                                                            onChange={() => handlePhaseChange(item.id)}
                                                                            key={"phase" + i}
                                                                            control={<Checkbox value={item.id} checked={selected(item.id, "phase")} />}
                                                                            label={item.text}
                                                                        />
                                                                    )}
                                                                </Stack>
                                                            </AccordionDetails>
                                                        </Accordion>

                                                        {/* Organisation selection  */}
                                                        <Accordion
                                                            expanded={expanded === 'panel3'}
                                                            onChange={handleOptionsChange('panel3')}
                                                            elevation={0}
                                                            sx={{
                                                                '&:before': {
                                                                    display: 'none',
                                                                }
                                                            }}
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={<EditIcon />}
                                                                aria-controls="panel3bh-content"
                                                                id="panel3bh-header"
                                                                sx={{ padding: 0 }}
                                                            >
                                                                <Typography sx={{ color: 'text.secondary' }}>
                                                                    {searchCriteria["fund"].filter(i => i.value === true).map(p => p.text).join(', ')}
                                                                </Typography>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                <Stack direction="column" alignItems="left" justifyContent="left" sx={{ my: 2 }}>
                                                                    {searchCriteria["fund"].map((item, j) =>
                                                                        <FormControlLabel
                                                                            onChange={() => handleFundChange(item.id)}
                                                                            key={"fund" + j}
                                                                            control={<Checkbox checked={selected(item.id, "fund")} value={item.id} />}
                                                                            label={item.text}
                                                                        />
                                                                    )}
                                                                </Stack>
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Stack>

                                            {/* Search button */}
                                            <LoadingButton
                                                onClick={() => submitSearch()}
                                                /*disabled={searchCount === undefined || searchCount.Item1 <= 0 || searchCount.Item1 > 1000}*/
                                                fullWidth
                                                size="large"
                                                type="submit"
                                                variant="contained"
                                                loading={loading}
                                                loadingPosition="start"
                                                startIcon={<Iconify icon="eva:search-fill" sx={{ color: "#fff", width: 20, height: 20 }} />}
                                                sx={{ my: 4 }}
                                            >
                                                {(searchCount === undefined || searchCount.Item1 === 0) ? "Search" :
                                                    (searchCount.Item1 <= 1000) ? "Show ( approx " + searchCount.Item2 + ")" : "Narrow search ( approx " + searchCount.Item2 + ")"}
                                            </LoadingButton>

                                        </Grid>
                                    </Grid>
                                </Grid>
                            </AuthCardWrapper>
                            <p>Powered by AWS and clinicaltrials.gov</p>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </AuthWrapper1 >
    );
}

SearchPage.propTypes = {
    loading: PropTypes.bool,
    apiWarmedUp: PropTypes.bool,
    searchCriteria: PropTypes.object,
};

